// How a player's name is shown in public: first name and surname initial
// ("Jane S."). Pure, so browser code can use it too.
export function shortName(full) {
  const parts = String(full || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return 'A Rendall’s player';
  return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1][0]}.` : parts[0];
}
